import type { DesktopFeatures } from '.';

export const desktopFeatureLabels: { [K in keyof DesktopFeatures]: string } = {
  duration: 'Listing duration',
  listing: "Appear on Australia's #1 business marketplace",
  connections: 'Receive emails from interested buyers',
  photo: 'Photo included in search results',
  searchRank: 'Appear higher in search results',
  boostedEmail: 'Include in daily buyer recommendation emails',
  featuredEmail: 'Feature at the top of search results',
  featuredSearch: 'Priority placement in daily buyer recommendation emails',
};

export const desktopRenderOrder: Array<keyof DesktopFeatures> = [
  'duration',
  'listing',
  'connections',
  'photo',
  'searchRank',
  'boostedEmail',
  'featuredEmail',
  'featuredSearch',
];

const desktopFeatureSortCompare = (a: string, b: string): number => {
  // "desktopRenderOrder as string[]" is safe as "indexOf" will return -1
  const indexOfA = (desktopRenderOrder as string[]).indexOf(a);
  const indexOfB = (desktopRenderOrder as string[]).indexOf(b);

  if (indexOfA < indexOfB) {
    return -1;
  } else if (indexOfA > indexOfB) {
    return 1;
  }
  return 0;
};

export const sortDesktopFeatures = <T>(features: {
  [K in keyof DesktopFeatures]: T;
}) =>
  Object.entries(features).sort((a, b) =>
    desktopFeatureSortCompare(a[0], b[0]),
  );
